<div style="text-align: center">
	<div class="simple-keyboard"></div>
</div>
